import { Card, Icon, WithPopover } from '@procurify/ui'

import { BudgetCategoryAttributeDescriptions } from '@webapp/components/Budgets/BudgetCategoryAttributeDescriptions'
import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import { BudgetCategoryAttributesPopoverStyled } from './styles/BudgetCategoryCardAttributesPopoverStyled'
import messages from '../../messages'

export interface IBudgetCategoryCardAttributesPopoverProps {
  departments?: string[]
  accountCodes?: string[]
  isSourceOfTruth?: boolean
}

export const BudgetCategoryCardAttributesPopover = ({
  departments,
  accountCodes,
  isSourceOfTruth,
}: IBudgetCategoryCardAttributesPopoverProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  const attributes = [
    ...(departments?.length
      ? [
          {
            label: intl.formatMessage(messages.secondaryOrgCategoryLabel),
            value: departments,
          },
        ]
      : []),
    ...(accountCodes?.length
      ? [
          {
            label: intl.formatMessage(messages.accountCodesLabel),
            value: accountCodes,
          },
        ]
      : []),
  ]

  const renderPopoverContent = () => {
    return (
      <Card.Content>
        <BudgetCategoryAttributeDescriptions
          attributes={attributes}
          isSourceOfTruth={isSourceOfTruth}
        />
      </Card.Content>
    )
  }

  return (
    <BudgetCategoryAttributesPopoverStyled>
      <WithPopover content={renderPopoverContent()}>
        <Icon
          ariaLabel={intl.formatMessage(
            FT_5817_ENABLE_BUDGETS_REDESIGN
              ? messages.attributesPopoverLabel
              : messages.oldAttributesPopoverLabel
          )}
          icon='question'
          ml={0.25}
        />
      </WithPopover>
    </BudgetCategoryAttributesPopoverStyled>
  )
}

BudgetCategoryCardAttributesPopover.displayName =
  'BudgetCategoryCardAttributesPopover'
